import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import mixpanel from "mixpanel-browser";

import {createBootstrap} from 'bootstrap-vue-next/plugins/createBootstrap'
import { createHead } from "@vueuse/head";

// Add the necessary CSS
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // adds collapse/toggler functionality

// Site styles (after Bootstrap to override)
import "/assets/styles.css";

const head = createHead()

// Create an instance of the Mixpanel object, your token is already added to this snippet
mixpanel.init('37dce2ce63970e7c50ae30a41b08b94f', {
  autocapture: true,
  record_sessions_percent: 100,
  api_host: 'https://api-eu.mixpanel.com',
})


const app = createApp(App)
app.use(head)
app.use(createBootstrap()) // Important
app.use(router)
app.mount('#app')